import Vue from 'vue'

// 全局指令：在任何组件内都可以使用
Vue.directive("checkPermit", {
  inserted(el,binding) {
    // console.log(bingd)
    const store_type = localStorage.getItem('store_type');
    if(store_type==1 || store_type == 2){
      const value = binding.value
      if (value && value instanceof Array && value.length > 0) {
        let permissions = localStorage.getItem('SYSTEM_PERMIT')
        const permissionPermissions = value

        if(permissions === null || permissions === '[0]'){
          return false
        }
        permissions = JSON.parse(permissions)

        // some() 方法会依次执行数组的每个元素：
        // 如果有一个元素满足条件，则表达式返回true , 剩余的元素不会再执行检测。
        // 如果没有满足条件的元素，则返回false。
        // 注意： some() 不会对空数组进行检测。
        // 注意： some() 不会改变原始数组。
        let is_allow =  permissions.some((role) => {
          // 数组的 includes() 方法用来判断一个数组是否包含一个指定的值，如果是返回 true，否则false。
          return permissionPermissions.includes(role)
        })

        if(!is_allow){
          el.style.display = `none`;
        }
      }
    }
  },
});


// 一、钩子函数
// 一个指令定义对象可以提供如下几个钩子函数 (均为可选)：
//
// bind：只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
//
// inserted：被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
//
// update：所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新 (详细的钩子函数参数见下)。
//
// 我们会在稍后讨论渲染函数时介绍更多 VNodes 的细节。
//
// componentUpdated：指令所在组件的 VNode 及其子 VNode 全部更新后调用。
//
// unbind：只调用一次，指令与元素解绑时调用。

// 二、钩子函数参数
// 指令钩子函数会被传入以下参数：
// el：指令所绑定的元素，可以用来直接操作 DOM。
// binding：一个对象，包含以下 property：
// name：指令名，不包括 v- 前缀。
// value：指令的绑定值，例如：v-my-directive=“1 + 1” 中，绑定值为 2。
// oldValue：指令绑定的前一个值，仅在 update 和 componentUpdated 钩子中可用。无论值是否改变都可用。
// expression：字符串形式的指令表达式。例如 v-my-directive=“1 + 1” 中，表达式为 “1 + 1”。
// arg：传给指令的参数，可选。例如 v-my-directive:foo 中，参数为 “foo”。
// modifiers：一个包含修饰符的对象。例如：v-my-directive.foo.bar 中，修饰符对象为 { foo: true, bar: true }。
// vnode：Vue 编译生成的虚拟节点。移步 VNode API 来了解更多详情。
// oldVnode：上一个虚拟节点，仅在 update 和 componentUpdated 钩子中可用。
// 除了 el 之外，其它参数都应该是只读的，切勿进行修改。如果需要在钩子之间共享数据，建议通过元素的 dataset 来进行。

// JS中作用域有：全局作用域、函数作用域。没有块作用域的概念。
// ECMAScript 6(简称ES6)中新增了块级作用域。块作用域由 { } 包括，
// if语句和for语句里面的{ }也属于块作用域。
//
// var
//   var定义的变量可以修改，如果不初始化会输出undefined，不会报错。
//   var 声明全局变量，换句话理解就是，声明在for循环中的变量，跳出for循环同样可以使用。
// let
//   同一个变量，不可在声明之前调用，必须先定义再使用，否则会报错，循环体中可以用let
//   let是块级作用域，函数内部使用let定义后，对函数外部无影响。并且let不能定义同名变量，否则会报错。
//   注意：必须声明'use strict';后才能使用let声明变量否则浏览并不能显示结果,
// const
//   const：用于声明常量，也具有块级作用域 ，也可声明块级。
//   const定义的变量不可以修改，而且必须初始化。
//   它和let一样，也不能重复定义同一个变量，const一旦定义，无法修改。



// WEBPACK FOOTER //
// ./src/assets/js/permission.js